import axios from "axios";
import { useBaseUrl } from "../../../context/AppContext";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Badge, InputGroup, Form, Spinner, Alert } from "react-bootstrap";
import { Search, Heart, Eye, MapPin, Calendar, CheckCircle } from "lucide-react";
import "../../../assets/css/donor/dashboard/BrowseCases.css";
import DonorLayout from "../../../layouts/donor/DonorLayout";

const BadgeStatus = ({ status }) => {

  const colors = {
    Approved: "success",
    Pending: "warning",
    Rejected: "danger",
    "Fee Support": "primary",
    Books: "info",
    Uniform: "warning",
    Verified: "success",
  };

  return <Badge bg={colors[status] || "secondary"}>{status}</Badge>;
};

const BrowseCases = () => {

  const baseUrl = useBaseUrl();

  const [casesRecords, setCasesRecords] = useState([]);
  const [filteredCases, setFilteredCases] = useState([]);

  const [selectedCaseType, setSelectedCaseType] = useState("Fee Support");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCase, setSelectedCase] = useState(null);

  const [loadingCases, setLoadingCases] = useState(false);
  const [donationLoading, setDonationLoading] = useState(false);

  const [error, setError] = useState("");

  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showDonateModal, setShowDonateModal] = useState(false);



  const viewAllCases = () => {

    setLoadingCases(true);
    setError("");

    axios.get(`${baseUrl}/donor/viewAllCases`)

      .then((response) => {

        if (response.data.cases) {
          setCasesRecords(response.data.cases);
        } else {
          setCasesRecords([]);
        }

        setLoadingCases(false);

      })

      .catch((error) => {

        console.log(error);
        setError("Failed to load cases");
        setLoadingCases(false);

      });

  };


  
  useEffect(() => {

    viewAllCases();

  }, [baseUrl]);


 
  useEffect(() => {

    const filtered = casesRecords.filter(

      (c) =>
        c.caseType === selectedCaseType &&
        (
          c.studentName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          c.institution?.toLowerCase().includes(searchQuery.toLowerCase())
        )

    );

    setFilteredCases(filtered);

  }, [casesRecords, searchQuery, selectedCaseType]);


 
  const handleViewDetails = (c) => {

    setSelectedCase(c);
    setShowDetailModal(true);

  };


  
  const handleDonate = (c) => {

    setSelectedCase(c);
    setShowDonateModal(true);

  };


  
  const handleCloseModal = () => {

    setSelectedCase(null);
    setShowDetailModal(false);
    setShowDonateModal(false);

  };


  
  const handleDonateSubmit = () => {

    setDonationLoading(true);

    const formData = new FormData();
    formData.append("case_id", selectedCase.id);

    axios.post(`${baseUrl}/donor/donateCase`, formData)

      .then((response) => {

        if (response.data.success) {

          alert("Donation Successful!");

          viewAllCases();
          handleCloseModal();

        } else {

          alert("Donation failed");

        }

        setDonationLoading(false);

      })

      .catch((error) => {

        console.log(error);
        alert("Something went wrong");
        setDonationLoading(false);

      });

  };


  return (

    <DonorLayout>

      <div className="dbc-container">

        <Container fluid>

          <Row className="dbc-header">

            <Col>

              <h2 className="dbc-title">
                Browse Cases - {selectedCaseType}
              </h2>

              <p className="dbc-subtitle">
                {filteredCases.length} cases found
              </p>

            </Col>

          </Row>


          

          <Row className="dbc-search-row mb-3">

            <Col lg={10}>

              <InputGroup>

                <InputGroup.Text>
                  <Search size={18} />
                </InputGroup.Text>

                <Form.Control
                  placeholder="Search by student or institute"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />

              </InputGroup>

            </Col>

            <Col lg={2} className="text-end">

              <Badge bg="info">
                {filteredCases.length} Found
              </Badge>

            </Col>

          </Row>


          {error && <Alert variant="danger">{error}</Alert>}



          <Row>

            <Col>

              <div className="dbc-table-wrapper">

                <table className="dbc-table">

                  <thead>

                    <tr>
                      <th>Student</th>
                      <th>Case</th>
                      <th>NGO</th>
                      <th>Location</th>
                      <th>Amount</th>
                      <th>Deadline</th>
                      <th>Actions</th>
                    </tr>

                  </thead>

                  <tbody>

                    {loadingCases ? (

                      <tr>

                        <td colSpan="7" className="text-center py-4">
                          <Spinner animation="border" />
                        </td>

                      </tr>

                    ) : filteredCases.length === 0 ? (

                      <tr>

                        <td colSpan="7" className="text-center py-4">
                          No cases found
                        </td>

                      </tr>

                    ) : (

                      filteredCases.map((c) => (

                        <tr key={c.id}>

                          <td>

                            <strong>{c.studentName}</strong>
                            <br />
                            <small>{c.institution}</small>

                          </td>

                          <td>
                            <BadgeStatus status={c.caseType} />
                          </td>

                          <td>
                            <CheckCircle size={14} /> {c.ngoName}
                          </td>

                          <td>
                            <MapPin size={14} /> {c.location}
                          </td>

                          <td>{c.amount}</td>

                          <td>
                            <Calendar size={14} /> {c.deadline}
                          </td>

                          <td>

                            <Button
                              size="sm"
                              className="me-2"
                              onClick={() => handleViewDetails(c)}
                            >
                              <Eye size={14} /> View
                            </Button>

                            <Button
                              size="sm"
                              variant="success"
                              onClick={() => handleDonate(c)}
                            >
                              <Heart size={14} /> Donate
                            </Button>

                          </td>

                        </tr>

                      ))

                    )}

                  </tbody>

                </table>

              </div>

            </Col>

          </Row>



          {showDonateModal && selectedCase && (

            <div className="dbc-modal-overlay" onClick={handleCloseModal}>

              <div
                className="dbc-modal"
                onClick={(e) => e.stopPropagation()}
              >

                <div className="dbc-modal-header">

                  <h3>Confirm Donation</h3>

                  <button onClick={handleCloseModal}>×</button>

                </div>

                <div className="dbc-modal-content text-center">

                  <p>
                    Donate <b>{selectedCase.amount}</b> to{" "}
                    <b>{selectedCase.studentName}</b>?
                  </p>

                  {donationLoading ? (

                    <Spinner />

                  ) : (

                    <Button onClick={handleDonateSubmit}>
                      Confirm Donation
                    </Button>

                  )}

                </div>

              </div>

            </div>

          )}

        </Container>

      </div>

    </DonorLayout>

  );

};

export default BrowseCases;